// ./Components/CrossPortalCards.js
// Card order is fixed (Legacy Version left, New Version right), not by
// "which one is this site". This is the cpv2 frontend, so the Legacy
// Version card is the internal one and the New Version card is the
// external link -- carrier-portal-frontend-3's own CrossPortalCards.jsx
// keeps this exact same left/right order with the interactive/external
// roles reversed, so the two apps read as one consistent design. Keep both
// in sync if this ever changes.
//
// No i18next here (this app has no i18n framework at all -- see
// identity/service/carriers.js's explanation object, which IS multi-locale,
// but this app only ever reads .en from it) -- all text hardcoded English,
// matching the rest of this codebase.
//
// The whole card is the clickable/tappable target -- an <a>, not a div with
// an onClick handler, for the same reason as the newer app's version
// (keyboard/focus semantics come free). Internal navigation uses
// history.push via onClick + href="#", matching this codebase's own
// established pattern (see Dashboard.js's "View Past Bids" link) rather
// than <Link>, which is never used anywhere in this app. A card whose own
// client list is empty renders as a plain non-interactive div instead of a
// link that would just bounce back to the same page.
//
// onContinueClick is optional -- when this is shown inside
// CrossPortalNoticeModal (already open ON /Dashboard), a real navigation
// there is a no-op that would leave the modal sitting open over content
// that didn't visibly change; passing this makes the Legacy Version card
// just close/dismiss the modal instead. PortalChooser (the "nothing here at
// all" page) omits it, getting the real internal navigation.

import React from "react";
import history from "../APIs/History";
import "./CrossPortalCards.css";

function CrossPortalCards({ thisPortalClients, otherPortalClients, otherPortalUrl, onContinueClick }) {
  const handlePortal2Click = (event) => {
    event.preventDefault();
    if (onContinueClick) {
      onContinueClick();
    } else {
      history.push("/Dashboard");
    }
  };

  const portal2Card =
    thisPortalClients.length > 0 ? (
      <a href="#" className="cross-portal-card" onClick={handlePortal2Click}>
        <h2>Legacy Version</h2>
        <p className="cross-portal-card-list-label">Customers:</p>
        <ul>
          {thisPortalClients.map((client) => (
            <li key={client.usercode}>{client.clientName}</li>
          ))}
        </ul>
        <span className="cross-portal-card-action">Continue to Legacy Version</span>
      </a>
    ) : (
      <div className="cross-portal-card cross-portal-card-empty">
        <h2>Legacy Version</h2>
        <p className="cross-portal-card-list-label">Customers:</p>
        <p className="cross-portal-card-no-clients">No clients.</p>
      </div>
    );

  const portal3Card =
    otherPortalClients.length > 0 ? (
      <a href={otherPortalUrl} target="_blank" rel="noopener noreferrer" className="cross-portal-card">
        <h2>New Version</h2>
        <p className="cross-portal-card-list-label">Customers:</p>
        <ul>
          {otherPortalClients.map((client) => (
            <li key={client.usercode}>{client.clientName}</li>
          ))}
        </ul>
        <span className="cross-portal-card-action">Go to New Version</span>
      </a>
    ) : (
      <div className="cross-portal-card cross-portal-card-empty">
        <h2>New Version</h2>
        <p className="cross-portal-card-list-label">Customers:</p>
        <p className="cross-portal-card-no-clients">No clients.</p>
      </div>
    );

  return (
    <div className="cross-portal-cards">
      {portal2Card}
      {portal3Card}
    </div>
  );
}

export default CrossPortalCards;
